export default __webpack_public_path__ + "static/media/SFProDisplay-Ultralight.fd1ec27f.woff2";